import { HttpContextToken } from '@angular/common/http';
import { RealmEnum }        from '@app/modules/user/models/user.model';

// ENUMS #############################################################
enum InterceptorIdentifierEnum {
	HEADER_CLIENT = 'headerClient',
	HEADER_CLIENT_ANALYTICS = 'headerClientAnalytics',
	HEADER_MANAGED_TENANT = 'headerManagedTenant',
	HEADER_MANAGED_TENANT_REALM = 'headerManagedTenantRealm'
}

export enum InterceptorXHeaderIdentifierEnum {
	HEADER_CLIENT = 'X-Client',
	HEADER_CLIENT_ANALYTICS = 'X-Client-Analytics',
	HEADER_MANAGED_TENANT = 'X-Managed-Tenant',
	HEADER_MANAGED_TENANT_REALM = 'X-Managed-Tenant-Realm'
}

// INTERFACES ########################################################
interface IInterceptorBase {
	enabled: boolean;
}

interface IHeaderInterceptorBase extends IInterceptorBase {
	xHeader?: InterceptorXHeaderIdentifierEnum;
}


export interface IHeaderClientInterceptor extends IHeaderInterceptorBase {
	clientIdentifier: 'FCP';
	xHeader?: InterceptorXHeaderIdentifierEnum.HEADER_CLIENT;
}

export interface IHeaderClientAnalyticsInterceptor extends IHeaderInterceptorBase {
	xHeader?: InterceptorXHeaderIdentifierEnum.HEADER_CLIENT_ANALYTICS;
}

export interface IHeaderManagedTenantInterceptor extends IHeaderInterceptorBase {
	tenantId: string;
	xHeader?: InterceptorXHeaderIdentifierEnum.HEADER_MANAGED_TENANT;
}

export interface IHeaderManagedTenantRealmInterceptor extends IHeaderInterceptorBase {
	realm: RealmEnum;
	xHeader?: InterceptorXHeaderIdentifierEnum.HEADER_MANAGED_TENANT_REALM;
}

export interface IHttpContextConfig {
	[ InterceptorIdentifierEnum.HEADER_CLIENT ]?: IHeaderClientInterceptor;
	[ InterceptorIdentifierEnum.HEADER_CLIENT_ANALYTICS ]?: IHeaderClientAnalyticsInterceptor;
	[ InterceptorIdentifierEnum.HEADER_MANAGED_TENANT ]?: IHeaderManagedTenantInterceptor;
	[ InterceptorIdentifierEnum.HEADER_MANAGED_TENANT_REALM ]?: IHeaderManagedTenantRealmInterceptor;
}


// TYPES #############################################################


// CONSTANTS #########################################################
export const HEADER_CLIENT_INTERCEPTOR: HttpContextToken<IHeaderClientInterceptor> =
	new HttpContextToken<IHeaderClientInterceptor>( () => (
		{ enabled: false, clientIdentifier: null }
	) );
export const HEADER_CLIENT_ANALYTICS_INTERCEPTOR: HttpContextToken<IHeaderClientAnalyticsInterceptor> =
	new HttpContextToken<IHeaderClientAnalyticsInterceptor>( () => (
		{ enabled: false }
	) );

export const HEADER_MANAGED_TENANT_INTERCEPTOR: HttpContextToken<IHeaderManagedTenantInterceptor> =
	new HttpContextToken<IHeaderManagedTenantInterceptor>( () => (
		{ enabled: false, tenantId: null }
	) );

export const HEADER_MANAGED_TENANT_REALM_INTERCEPTOR: HttpContextToken<IHeaderManagedTenantRealmInterceptor> =
	new HttpContextToken<IHeaderManagedTenantRealmInterceptor>( () => (
		{ enabled: false, realm: null }
	) );
